import { C, EASE_SPRING, ink, PAGE_BG } from '../lib/theme';
import { IconAlert } from '../components/icons';

/**
 * Tela de bloqueio: o login no Supabase deu certo, mas o email não está na
 * allowlist (revops_app_users) ou foi desativado. O texto é o mesmo que o
 * backend devolve em `no_access`, e não distingue "nunca convidado" de
 * "desativado" — dizer qual é dos dois vazaria informação sobre o ambiente.
 */
export function AccessDenied({ email, onSignOut }: { email: string; onSignOut: () => void }) {
  return (
    <div style={{
      minHeight: '100vh', background: PAGE_BG, color: C.fg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative',
    }}>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none' }}>
        <div style={{
          position: 'absolute', width: 620, height: 620, borderRadius: '50%', filter: 'blur(100px)',
          opacity: 0.22, top: -220, left: -140,
          background: `radial-gradient(circle at 40% 40%, ${C.churn}, transparent 68%)`,
          animation: 'koDrift1 18s ease-in-out infinite alternate',
        }} />
      </div>

      <div style={{
        position: 'relative', width: '100%', maxWidth: 420, padding: 32, textAlign: 'center',
        background: ink(0.045), border: `1px solid ${ink(0.1)}`, borderRadius: 24,
        backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        boxShadow: '0 30px 90px rgba(8,8,16,0.5)',
        animation: `koSlideIn 0.4s ${EASE_SPRING}`,
      }}>
        <div style={{
          width: 52, height: 52, borderRadius: 18, margin: '0 auto 16px',
          background: 'rgba(242,85,90,0.14)', color: C.churn,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24,
        }}><IconAlert size={26} /></div>

        <div style={{ fontSize: 19, fontWeight: 780, letterSpacing: '-0.02em' }}>
          Você não tem acesso a esse ambiente
        </div>

        <div style={{ fontSize: 13.5, color: ink(0.5), marginTop: 10, lineHeight: 1.6 }}>
          A conta <strong style={{ color: ink(0.75) }}>{email}</strong> não está autorizada no Kory RevOps Hub.
          Peça a um administrador para liberar seu acesso.
        </div>

        <button type="button" onClick={onSignOut} style={{
          width: '100%', marginTop: 22, border: `1px solid ${ink(0.16)}`, background: ink(0.06),
          color: C.fg, cursor: 'pointer', font: 'inherit', fontSize: 13.5, fontWeight: 700,
          padding: '11px 0', borderRadius: 12,
        }}>Sair e entrar com outra conta</button>
      </div>
    </div>
  );
}
